// extracted by css-extract-rspack-plugin
export default {"queryResizableBox":"k7EnL","nativeQueryEditor":"x82mW","readOnly":"VztI9"};